const SALES_TARGET_BY_KEY = {
	COMMISSION: { value: 'COMMISSION', label: 'Комиссия' },
	ABONENT: { value: 'ABONENT', label: 'Абонентка' },
	NO_PERSPECTIVE: { value: 'NO_PERSPECTIVE', label: 'Бесперспективный' },
};

const COMMISSION_PRIORITY_BY_KEY = {
	IMPORTANT: { value: 'IMPORTANT', label: 'Важный' },
	USEFUL: { value: 'USEFUL', label: 'Полезный' },
};

const SALES_TARGET_ALIASES = {
	commission: 'COMMISSION',
	COMMISSION: 'COMMISSION',
	abonent: 'ABONENT',
	ABONENT: 'ABONENT',
	noperspective: 'NO_PERSPECTIVE',
	no_perspective: 'NO_PERSPECTIVE',
	noPerspective: 'NO_PERSPECTIVE',
	NO_PERSPECTIVE: 'NO_PERSPECTIVE',
};

const COMMISSION_PRIORITY_ALIASES = {
	important: 'IMPORTANT',
	IMPORTANT: 'IMPORTANT',
	useful: 'USEFUL',
	USEFUL: 'USEFUL',
};

const normalizeKey = (value) => {
	if (value == null || value === '') return '';

	if (typeof value === 'object' && value.value != null) {
		return String(value.value);
	}

	return String(value);
};

export const toSalesTargetEnum = (value) => {
	const raw = normalizeKey(value);

	if (!raw) return '';

	return (
		SALES_TARGET_ALIASES[raw] ||
		SALES_TARGET_ALIASES[raw.replace(/_/g, '')] ||
		''
	);
};

export const toCommissionPriorityEnum = (value) => {
	const raw = normalizeKey(value);

	if (!raw) return '';

	return COMMISSION_PRIORITY_ALIASES[raw] || '';
};

export const SALES_TARGET_OPTIONS = Object.values(SALES_TARGET_BY_KEY);

export const COMMISSION_PRIORITY_OPTIONS = Object.values(
	COMMISSION_PRIORITY_BY_KEY,
);

export const SALES_TARGET_FILTER_OPTIONS = SALES_TARGET_OPTIONS;

export const COMMISSION_PRIORITY_FILTER_OPTIONS = COMMISSION_PRIORITY_OPTIONS;

export const getSalesTargetLabel = (value) => {
	const key = toSalesTargetEnum(value);

	return SALES_TARGET_BY_KEY[key]?.label ?? (value ? String(value) : '—');
};

export const getCommissionPriorityLabel = (value) => {
	const key = toCommissionPriorityEnum(value);

	return (
		COMMISSION_PRIORITY_BY_KEY[key]?.label ?? (value ? String(value) : '—')
	);
};

export const resolveWorthValue = (worth) =>
	worth?.value ?? worth?.valueAuto ?? null;

export const formatWorthWithPriority = (value, commissionPriority) => {
	if (value == null || value === '') return null;

	const priorityKey = toCommissionPriorityEnum(commissionPriority);
	const label = COMMISSION_PRIORITY_BY_KEY[priorityKey]?.label;

	if (!label) return value;

	return `${value} (${label})`;
};

export const isCommissionSalesTarget = (value) =>
	toSalesTargetEnum(value) === 'COMMISSION';

export const mapCompanySalesTarget = (company) => {
	if (!company) return '—';

	return getSalesTargetLabel(company.salesTarget);
};

export const mapCompanyCommissionPriority = (company) => {
	if (!company || !isCommissionSalesTarget(company.salesTarget)) {
		return '—';
	}

	return getCommissionPriorityLabel(company.commissionPriority);
};

export const mapSalesTargetFormValues = (company) => {
	const salesTargetKey = toSalesTargetEnum(company?.salesTarget);
	const priorityKey = toCommissionPriorityEnum(company?.commissionPriority);

	return {
		salesTarget: SALES_TARGET_BY_KEY[salesTargetKey] ?? null,
		commissionPriority: COMMISSION_PRIORITY_BY_KEY[priorityKey] ?? null,
	};
};

export const mapSalesTargetFormToInput = (values) => {
	const salesTarget = toSalesTargetEnum(values?.salesTarget) || null;
	const commissionPriority = isCommissionSalesTarget(salesTarget)
		? toCommissionPriorityEnum(values?.commissionPriority) || null
		: null;

	return { salesTarget, commissionPriority };
};

export const hasSalesTargetFormChanges = (values, company) => {
	const next = mapSalesTargetFormToInput(values);
	const current = mapSalesTargetFormToInput(mapSalesTargetFormValues(company));

	return (
		next.salesTarget !== current.salesTarget ||
		next.commissionPriority !== current.commissionPriority
	);
};
